export default "__VITE_ASSET__BCDD6zAV__"